export var MR_OAUTH_CLIENT_ID = 'dfd7d5b5994048b7b10c06f0fa388d9a';